export default __webpack_public_path__ + "static/media/server.fda02226.svg";